<div class="flex justify-between content-center">
  <h3 mat-dialog-title data-test-id="share-expert-dialog-title">
    Share expert
  </h3>
  <button mat-icon-button mat-dialog-close>
    <mat-icon data-test-id="share-expert-dialog-close">clear</mat-icon>
  </button>
</div>

<mat-dialog-content class="flex flex-col">
  <form class="flex flex-col gap-8" [formGroup]="submissionForm">
    <mat-form-field appearance="outline">
      <mat-label data-test-id="share-expert-dialog-recipients-label"
        >Recipient(s)</mat-label
      >
      <mat-chip-grid
        #chipList
        formControlName="recipients"
        data-test-id="share-expert-dialog-recipients"
      >
        @for (email of submissionFormEmails; track email) {
          <mat-chip
            data-test-id="chip-list-item"
            [removable]="true"
            (removed)="removeEmail(email)"
          >
            <span class="chip-text">{{ email }}</span>
            <mat-icon matChipRemove data-test-id="chip-list-item-remove"
              >cancel</mat-icon
            >
          </mat-chip>
        }
        <input
          [matChipInputFor]="chipList"
          (matChipInputTokenEnd)="addEmail($event)"
        />
      </mat-chip-grid>
      @if (recipientsControl.hasError('required')) {
        <mat-error data-test-id="share-expert-dialog-recipients-error"
          >One valid email is required
        </mat-error>
      }
      @if (recipientsControl.hasError('emailValidator')) {
        <mat-error data-test-id="share-expert-dialog-recipients-error">
          All emails must be valid</mat-error
        >
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label data-test-id="share-expert-dialog-message-label"
        >Message to recipient(s)</mat-label
      >
      <textarea
        matInput
        style="min-height: 200px; resize: none"
        placeholder="Please could you review this expert"
        formControlName="notes"
        data-test-id="share-expert-dialog-message"
      ></textarea>
      <mat-error data-test-id="share-expert-dialog-message-error"
        >Message is required</mat-error
      >
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button
    type="button"
    mat-stroked-button
    mat-dialog-close
    color="primary"
    data-test-id="share-expert-dialog-cancel"
    class="flex-1 primaryColor-border"
  >
    Close window
  </button>
  <button
    type="submit"
    mat-flat-button
    class="flex-1"
    color="primary"
    data-test-id="share-expert-dialog-confirm"
    (click)="submit()"
  >
    Confirm
  </button>
</mat-dialog-actions>
